import { Grid } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
} from '../../features/modelo-numerario/modeloNumerarioSlice';
import {
  fetchAllAsync,
  selectStatus,
  selectTabelasSda,
} from '../../features/tabela-sda/tabelaSdaSlice';
import QCXSimpleSelectOnePageTemplate from '../../templates/simple-select-one-page/QCXSimpleSelectOnePageTemplate';
import { isAlternativeLoadingStatus } from '../../utils/store/store-utils';

export default function QCXSelectOneTabelaSdaTable({ ...props }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const tabelasSda = useSelector(selectTabelasSda);

  const isAlternativeLoading = useMemo(() => (
    isAlternativeLoadingStatus(status)
  ), [status]);

  useEffect(() => {
    dispatch(fetchAllAsync());
  }, []);

  const filterProps = [
    'id',
    'description',
  ];

  const {
    title = t('com.muralis.qcx.tabelaSDA.selecioneTabelaSDA'),
    filterProp = 'description',
    columns = [
      {
        field: 'id',
        headerName: t('com.muralis.qcx.codigo'),
        headerAlign: 'center',
        align: 'center',
        flex: 50,
      },
      {
        field: 'description', headerName: t('com.muralis.qcx.tabelaSDA.label'), flex: 300,
      },
      {
        field: 'active', headerName: t('com.muralis.qcx.estado.ativo'), type: 'boolean', flex: 50,
      },
    ],
    selected = null,
    handleChange,
    isConsult,
    ...restProps
  } = props;

  return (
    <>
      <Grid container direction="row" style={{ marginTop: '0.7rem' }}>
        <QCXSimpleSelectOnePageTemplate
          title={title}
          tableColumns={columns}
          tableData={tabelasSda}
          filterProp={filterProp}
          isLoading={isAlternativeLoading}
          isConsult={isConsult}
          handleSetSelected={handleChange}
          selected={selected}
          multipleFilter
          filterProps={filterProps}
          {...restProps}
        />
      </Grid>
    </>
  );
}
